<template>
  <div class="img-hover-wrap">
    <div class="position-relative">

      <div class="img-action-block">
        <div>
          <a class="p-2" @click="viewImage">
            <EyeSvg class="svg-size-md svg-white"/>
          </a>
          <a class="p-2" @click="uploadInitial">
            <UploadSvg class="svg-size-md svg-stroke-white"/>
          </a>
        </div>
      </div>

      <DesktopCameraCapture @captured="processFile"
                            ref="desktopCameraCapture"
                            @browse="browseManualLaunch"/>

      <label for="patientimgfile" class="pointer mb-0">
        <img class="patient-img"
             :style="bordercolor ? `border: 4px solid ${bordercolor};` : ''"
             :src="user.photo"
             alt=""
             :title="user.full_name"/>
      </label>
      <span class="patient-img-warning"
            v-if="user.importantNotes"
            v-b-popover.hover="user.importantNotes"><WarningSvg class="svg-red"/></span>
      <input type="file"
             id="patientimgfile"
             accept="image/*"
             class="d-none"
             ref="patientimgfile"
             @change="processInput($event)"/>
    </div>
    <expandable-image class="img-preview"
                      ref="expImage"
                      alt="image"
                      :src="user.photo"/>
  </div>

</template>

<script setup>
import { useStore} from "vuex"
import WarningSvg from '@/assets/svg-vue/general/warning.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import { computed, getCurrentInstance, onBeforeMount, ref } from "vue"
import { appendFormdata } from "@/extensions/prototypes/prototypes"
import DesktopCameraCapture from "@/components/parts/patients/DesktopCameraCapture.vue"
import EyeSvg from '@/assets/svg-vue/form/eye.svg'
import UploadSvg from '@/assets/svg-vue/patients/upload.svg'

const props = defineProps({
  view: {
    type: String,
    default: 'patient'
  },
  bordercolor: {
    type: String,
    default: null,
  }
})

let i18n = null
let noty = null

const store = useStore()

const patient = computed(() => store.state.patient.patient)
const doctor = computed(() => store.state.doctor.doctor)
const isMobile = computed(() => store.state.dom.isMobile)

const user = computed(() => (props.view === 'doctor') ? doctor.value : patient.value)

const sizelimit = ref(1) // in MB
const form = ref({})
const expImage = ref()
const desktopCameraCapture = ref()

onBeforeMount(() => {
  const instance = getCurrentInstance()
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const processInput = (event) => {
  let file = event.target.files[0]
  if(!file) {
    return
  }
  processFile(file)
}

const processFile = (file) => {
  if(file.size > (sizelimit.value * 1024 * 1024)) {
    noty.error(i18n.t('file_size_is_too_big'))
    return
  }
  form.value = {
    image: file,
    lname: user.value.lname,
    mname: user.value.mname,
    fname: user.value.fname,
    mphone: user.value.mphone,
    percent: user.value.percent,
    rate: user.value.rate,
    card: user.value.card,
    mode: 'image'
  }
  upload()
}

const upload = () => {
  let formData = new FormData()
  formData = appendFormdata(formData, form.value)
  if(props.view === 'doctor') {
    EloquentService.update('doctor', user.value.id, formData).then(() => {
      store.dispatch('getDoctor', user.value.id)
    }).catch(err => {
      console.error(err)
    })
  }
  if(props.view === 'patient') {
    EloquentService.update('patient', user.value.id, formData).then(() => {
      store.dispatch('getPatient', user.value.id)
    }).catch(err => {
      console.error(err)
    })
  }
}

const browseManualLaunch = () => {
  document.getElementById('patientimgfile').click()
}

const viewImage = () => {
  const img = expImage.value?.$el?.querySelector('img')
  if (img) img.click()
}

const uploadInitial = () => {
  if(isMobile.value) {
    browseManualLaunch()
  } else {
    desktopCameraCapture.value?.launchDropdown()
  }
}
</script>

<style scoped lang="scss">
.patient-img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 100%;
}
.patient-img-warning {
  position: absolute;
  top: 0;
  right: 0;
  border: 2px solid #fff;
  font-size: 0;
  z-index: 2;
  border-radius: 100%;
  background-color: #fff;
}
.img-preview {
  display: none;
}
.img-action-block {
  display: none;
  position: absolute;
  background: rgba(0,0,0,0.5);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  a {
    cursor: pointer;
  }
}
.img-hover-wrap {
  &:hover {
    .img-action-block {
      display: flex;
    }
  }
}
</style>
